import { Component } from '@angular/core';

@Component({
  selector: 'app-popcorn-before-page',
  templateUrl: './popcorn-before-page.component.html',
  styleUrls: ['./popcorn-before-page.component.scss']
})
export class PopcornBeforePageComponent {

}
